<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Operating Area - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item v-if="role =='super_admin' || role =='operations_manager'" @click="editOA">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteOperatingArea">Delete</b-dropdown-item>
					<b-dropdown-item :disabled="!assign" @click="editAssign()">Assign All Drivers</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<!-- <b-tab title="Operating Area" active> -->
						<b-row>
							<b-col md="8">
								<b-form-group :label-cols="4" horizontal label="Id" label-for="id" >
									<b-form-input class="plaintext-input" plaintext id="id" v-model="model.id" type="text"></b-form-input>									
								</b-form-group>
								<b-form-group label="Operating Area Name" label-for="OperatingANameID" :label-cols="4" horizontal>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="OperatingANameID" v-model="model.name" type="text"></b-form-input>
									<b-form-input class="plaintext-input" v-show="edit" id="OperatingANameID" v-model="model.name" type="text"></b-form-input>
								</b-form-group>

								<b-form-group v-show="view" label="Energy Company" label-for="EnergyCompanyID" :label-cols="4" horizontal>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="EnergyCompanyID" v-model="model.energy_company_name" type="text"></b-form-input>
									<b-form-select v-show="edit" value-field="id" text-field="company_name" id="EnergyCompanyID" v-model="model.energy_company_id" :options="energycompanyselect" placeholder="Select Location Type"  @input="select_energy_company"/>
								</b-form-group>
								<b-form-group :label-cols="4" id="L11" label="Company Cosigner" label-for="company_cosigner" horizontal>
									<b-form-input v-if="!edit" id="company_cosigner" class="plaintext-input" plaintext type="text" v-model="model.company_cosigner"></b-form-input>
									<b-form-input v-else id="company_cosigner" type="text" v-model="model.company_cosigner"  autocomplete="off"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L13" label="Phone Number" label-for="phone_number" horizontal>
									<b-form-input v-if="!edit" id="phone_number" class="plaintext-input" plaintext type="tel" v-model="model.phone_number"></b-form-input>
									<b-form-input v-else id="phone_number" placeholder="##########" v-mask="'##########'" type="tel" autocomplete="off" v-model="model.phone_number"></b-form-input>
								</b-form-group>

								<b-form-group v-if="model.load_locations.length > 0 && !edit" :label-cols="4" id="L5" label="Load Locations" label-for="loadLocationsID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.load_locations" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
								</b-form-group>

								<b-form-group v-if="model.unload_locations.length > 0 && !edit" :label-cols="4" id="L5" label="Unload Locations" label-for="unloadLocationsID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.unload_locations" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
								</b-form-group>
								<b-form-group v-if="loadlocationselect.length > 0 && edit" :label-cols="4" id="L5" label="Load Locations" label-for="loadLocationsID" horizontal>
									<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
										{{ llAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>
								<b-form-group v-if="unloadlocationselect.length > 0 && edit" :label-cols="4" id="L5" label="Unload Locations" label-for="unloadLocationsID1" horizontal>
									<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="model.unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">
										{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
								<div slot="footer" v-show="edit">
									<b-button @click="updateOperatingArea(model)" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editOA" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
						</b-row>
							
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
		<!-- Configure Columns to Display -->
    <b-modal title="Select Trucking Companies" v-model="addUsers" ok-variant="primary">
      <b-container class="bv-example-row">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12">
			<b-form-group v-if="truckingcompanyselect.length > 0" :label-cols="1" id="TC4" label="" label-for="TcID" horizontal>	
				<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="truckingcompanyselect" name="Checkboxes2" plain v-model="model.trucking_companies_id" @input="truckingcompanyChange"></b-form-checkbox-group>
				<b-form-checkbox style="margin-top: 5px;" v-model="AllSelectedtc" :indeterminate="indeterminatetc" aria-describedby="" aria-controls="" plain @change="TCToggleAll">
					{{ AllSelectedtc ? 'Un-select All' : 'Select All' }}
				</b-form-checkbox>
			</b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="editAssign() ">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="assigndrivers">
          Assign
        </b-btn>
      </div>

    </b-modal>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import vSelect from 'vue-select'
	import axios from 'axios'
	import {
		apiDomain
	} from '../../config'
	import operating_areas_service from './operating_areas_service'
	
	
	const items = []
	export default {
		name: 'm_operating_area',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			// this.getTruckingCompanies()
			this.getOperatingAreasData()
		},
		data() {
			return {
				indeterminateLL		: false,
				isSuperAnalyst		: false,
				llAllSelected		: false,
				indeterminateUL		: false,
				ulAllSelected		: false,

				updateData			: null,
				originalData		: null,

				operatingareaselect	: [],
				energycompanyselect	: [],
				loadlocationselect	: [],
				unloadlocationselect: [],

				model: {
					id					: null,
					name				: '',
					energy_company_id	: '',
					company_cosigner    : '',
          			phone_number        : '',
					load_locations_id	: [],
					unload_locations_id	: [],
					unload_locations	: [],
					load_locations		: [],
					trucking_companies 	: [],
					trucking_companies_id 	: []
				},

				subTitle: "",
				edit: false,

				loadingData				: true,
				tabIndex				: 0,
				found					: false,
				notFoundMessage			: 'Not found',

				items					: items,
				role					:'',
				view					:true,
				view1					:true,
				energy_company_id 		:null,
				// Added by Carlos Rondon 14/02/2019 trucking company 
				truckingcompanyselect 	: [],
				AllSelectedtc			: false,
				indeterminatetc			: false,
				assign					: true,
				addUsers            	: false,
				// End Added
			}
		},
		methods: {
			editAssign() {
				if (this.addUsers) {
					this.addUsers = false
				} else {
					if (this.role !='trucking_company_admin' || this.role =='trucking_operational_manager') {
						this.addUsers = true
						this.model.trucking_companies_id = []
					} else {
						this.assigndrivers()
					}
				}				
			},
			allCheckedLL() {
				//return Array(this.model.load_locations.length).fill(true)
			},
			allCheckedUL() {
				//return Array(this.model.unload_locations.length).fill(true)
			},
			allCheckedLL1() {
				//return Array(this.model1.load_locations.length).fill(true)
			},
			allCheckedUL1() {
				//return Array(this.model1.unload_locations.length).fill(true)
			},
			allCheckedTC() {
				//return Array(this.model1.trucking_companies.length).fill(true)
			},
			restoreOriginalData() {
				let model = {
					...this.originalData, 
					unload_locations_id: [],
					load_locations_id: [],
					trucking_companies_id : []
				}
				this.model = model
				this.unloadlocationselect		= this.updateData.unload_locations
			},
			getOperatingAreasData() {
				operating_areas_service.getBy(this.id)
					.then(data => {
						if (data[0] == 'success') {
							this.originalData = data[1]
							this.updateData = data[2]
							this.restoreOriginalData()
							this.energycompanyselect = this.updateData.energy_companies
							this.truckingcompanyselect = this.updateData.trucking_companies
							this.subTitle = this.originalData.name
							this.found = true
							this.loadingData = false

							this.role = data[3]
							if (this.role =='super_admin') {
								this.view=true
								this.view1=true
							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
								this.view=false
								this.view1=true
								this.energy_company_id = data[4]
							} else if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
								this.view=true
								this.view1=false
								this.model.trucking_companies_id = this.truckingcompanyselect[0].id
							} else if (this.role =='operations_manager') {
								this.view=false
								this.view1=true
								this.energy_company_id 			= data[4]
								this.model.energy_company_id 	= this.energy_company_id
								// this.select_energy_company()
							} 
							this.get_attributtes()
						} else {
							this.loadingData = false
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.role =='super_admin') {
					if(this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
					}
				}
				if (this.model.name === undefined || this.model.name.trim().length == 0) {
					this.$swal('Alert!', 'Operating Area Name can not be empty', 'warning')
					return false
				} 
				return true
			},
			updateOperatingArea(model) {
				if (!this.okToUpdate()) {
					return
				}
				let t1=this.model.load_locations_id
				let t2=this.model.unload_locations_id
				//let t3=this.model.trucking_companies_id
				let t3=[]
				if (this.model.trucking_companies_id.length!=0) {
					t3=this.model.trucking_companies_id.map(item => {
						return {
							id: String(item)
						}
					})
				} 
				model = {
					name				: model.name,
					energy_company_id	: model.energy_company_id,
					company_cosigner	: this.model.company_cosigner,
					phone_number		: this.model.phone_number,
					load_locations: t1.map(item => {
						return {
							id: String(item)
						}
					}),
					unload_locations: t2.map(item => {
						return {
							id: String(item)
						}
					}),
					trucking_company: t3
				}

				this.model.id = this.id
				operating_areas_service.update(this.id, model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
						if (data[0] == 'success') {
							this.getOperatingAreasData() 
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteOperatingArea() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Operating Area: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						operating_areas_service.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.$router.push('/operating_areas')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			editOA() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			select_energy_company() {
				if (this.role =='super_admin' || this.role =='operations_manager' || this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {

						/* let trucking_companies      = this.model.trucking_companies
          				let trucking_companies_id   = this.model.trucking_companies_id
						let new_loadlocations     = []
						trucking_companies.forEach(function(e){
                      		new_loadlocations=new_loadlocations.concat(e.load_locations)
						}) */
						let energy_companies = this.updateData.energy_companies
						let loadlocations = []
						let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
						if (energy_company_index > -1) {
							loadlocations = energy_companies[energy_company_index].load_locations
						} 

						this.loadlocationselect = loadlocations    //this.arrayUnique(loadlocations.concat(new_loadlocations))
					//this.model.load_locations_id = []
				}
			},
			LLToggleAll(checked) {
				this.model.load_locations_id = checked ? this.loadlocationselect.map(item => {
					return item.id
				}) : []
			},
			ULToggleAll(checked) {
				this.model.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
					return item.id
				}) : []
			},
			TCToggleAll(checked) {
				this.model.trucking_companies_id = checked ? this.truckingcompanyselect.map(item => {
					return item.id
				}) : []
			},
			loadLocationsChange() {
				if (this.role =='super_admin' || this.role =='operations_manager') {
					if (this.model.load_locations_id===null) {
						return
					}
					if (this.model.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
				}
				}
			},
			unloadLocationsChange() {
				if (this.role =='super_admin' || this.role =='operations_manager') {
					if (this.model.unload_locations_id===null) {
						return
					}
					if (this.model.unload_locations_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
					}
				}
			},
			truckingcompanyChange() {
				if (this.role =='super_admin') {
					// Added 22/02/2019
					if (this.model.trucking_companies_id===null){
						return
					}
					// let trucking_companies_id 	= this.model.trucking_companies_id
					// let trucking_companies 		= this.updateData.trucking_companies
					/* let new_loadlocations   	= []
					for (var i = 0; i < trucking_companies_id.length; i+=1) {
						let trucking_company_index 	= trucking_companies.map(o => o.id).indexOf(trucking_companies_id[i])
						if (trucking_company_index > -1) {
							let loadlocations = trucking_companies[trucking_company_index].load_locations
							new_loadlocations= this.arrayUnique(new_loadlocations.concat(loadlocations))
						} 
					  }
					  
					let energy_companies = this.updateData.energy_companies
					let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
					let loadlocations     = []
					if (energy_company_index > -1) {
						loadlocations = energy_companies[energy_company_index].load_locations
					} 
					this.loadlocationselect = this.arrayUnique(loadlocations.concat(new_loadlocations))  */
        			// End Added
					if (this.model.trucking_companies_id.length === 0) {
						this.indeterminatetc = false
						this.AllSelectedtc = false
					} else if (this.model.trucking_companies_id.length === this.truckingcompanyselect.length) {
						this.indeterminatetc = false
						this.AllSelectedtc = true
					} else {
						this.indeterminatetc = true
						this.AllSelectedtc = false
				}
				}
			},
			setupFields() {
					// Added 22/02/2019
				/* let trucking_companies      = this.model.trucking_companies
          		let trucking_companies_id   = this.model.trucking_companies_id
				let new_loadlocations     = []
				trucking_companies.forEach(function(e){
                    new_loadlocations=new_loadlocations.concat(e.load_locations)
				})  */
				this.model.trucking_companies_id = []
				let energy_companies = this.updateData.energy_companies

				let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
				let loadlocations     = []
				if (energy_company_index > -1) {
					loadlocations = energy_companies[energy_company_index].load_locations
				} 


				//this.loadlocationselect = this.arrayUnique(loadlocations.concat(new_loadlocations))
				
				if(loadlocations.length > 0) {
					this.loadlocationselect = this.arrayUnique(loadlocations)
				} else {
					this.loadlocationselect = []
				}
				if(this.model.load_locations.length > 0) {
					this.model.load_locations_id = this.model.load_locations.map(item => {
						return item.id
					})
				} 

				if(this.model.unload_locations.length > 0) {
					this.model.unload_locations_id = this.model.unload_locations.map(item => {
						return item.id
					})
				} 

				this.model.trucking_companies_id = []
				/* if(this.model.trucking_companies.length > 0) {
					this.model.trucking_companies_id = this.model.trucking_companies.map(item => {
						return item.id
					})
				} */
			},
			arrayUnique(array) {
    			var a = array.concat();
    			for(var i=0; i<a.length; ++i) {
        			for(var j=i+1; j<a.length; ++j) {
            			if(a[i].id === a[j].id)
                			a.splice(j--, 1);
        			}
    			}
    			return a;
			},
			assigndrivers() {
				this.assign = false
				let model = {
					operating_area_id   : this.id,
					energy_company_id	: this.model.energy_company_id,
					load_locations		: this.model.load_locations,
					unload_locations	: this.model.unload_locations,
					trucking_companies	: this.model.trucking_companies_id 
				}
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to assign all drivers to trucking companies selected?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						operating_areas_service.assigndrivers(this.id, model)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									console.log('good')
									this.assign = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
				this.addUsers = false
			},
			get_attributtes() {
				operating_areas_service.get_attr_update()
					.then(data => {
						if (data[0] === 'success') {
							this.updateData.energy_companies 	= data[1]
							this.energycompanyselect 			= this.updateData.energy_companies
							if (this.role =='operations_manager') {
								this.select_energy_company()
							} 
						} else {
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error1', 'Server not response. ' + error, 'error')
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/operating_areas/m_operating_area.vue